/**
 * Колбэки окон (C4) — что делает кнопка за пределами окна. Окна сами только закрываются; бой, API и шаринг
 * подключают владельцы через {@link setWindowActions}.
 *
 * Здесь общие для нескольких окон. Своё окно объявляет в `<окно>/actions.ts`: дополняет {@link WindowActions} и
 * отдаёт `defaults`, файл подхватывается сам. Без подключения колбэки ничего не делают (окна всё равно закрываются).
 */
import type { AdminToolRequest, OfferPlace, Product, ShopItem } from "@newfungame/contracts";
import { createStore } from "../../app";

export interface WindowActions {
  /** Обмен: кристаллы или билет на таймер, час x2, мешок, героя. */
  spend(item: ShopItem): void | Promise<void>;
  /** Кнопки ускорения админа: снять таймер, добавить монет. */
  adminTool(action: AdminToolRequest["action"]): void | Promise<void>;
  /** «Дальше» / «В бой» из окон итогов (I1, если бою нужно знать о закрытии; по умолчанию ничего). */
  nextWave(): void;
  /** Счёт Telegram Stars (`app/payments.ts`); обещание завершается, когда счёт закрыт. */
  buy(product: Product, place: OfferPlace): void | Promise<void>;
  /** На сайте и у гостя вместо покупки: открыть игру в Telegram. */
  openTelegram(place: OfferPlace): void;
  /** Предложение покупки показано (аналитика). */
  offerShown(place: OfferPlace): void;
  /** Стартовый пакет показан: один раз на игрока. */
  starterShown(place: OfferPlace): void;
}

const noop = () => {};

const features = import.meta.glob<{ defaults: Partial<WindowActions> }>("./*/actions.ts", { eager: true });

const shared: Partial<WindowActions> = {
  spend: noop,
  adminTool: noop,
  nextWave: noop,
  buy: noop,
  openTelegram: noop,
  offerShown: noop,
  starterShown: noop,
};

export const NOOP_ACTIONS = Object.assign(shared, ...Object.values(features).map((f) => f.defaults)) as WindowActions;

export const windowActions = createStore<WindowActions>(NOOP_ACTIONS);

/** Подключить колбэки (частично: остальные остаются прежними). */
export function setWindowActions(actions: Partial<WindowActions>): void {
  windowActions.set((a) => ({ ...a, ...actions }));
}

/** Текущие колбэки — зовутся в момент нажатия, не при отрисовке. */
export function actions(): WindowActions {
  return windowActions.get();
}
